module.exports = __webpack_public_path__ + "img/10-Crystal White.jpg";